(() => {
  const normalize = (value, rule = {}) => {
    const min = Math.max(1, Number(rule.min) || 1);
    const step = Math.max(1, Number(rule.increment) || 1);
    const max = rule.max == null ? Infinity : Math.max(min, Number(rule.max));
    const requested = Number.isFinite(Number(value)) ? Number(value) : min;
    const last = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
    return Math.min(last, min + Math.max(0, Math.round((requested - min) / step)) * step);
  };
  const bind = (controls, update) => {
    const abort = new AbortController();
    for (const control of controls) {
      const input = control.querySelector('[data-ac-product-quantity]');
      if (!input) continue;
      const ink = control.querySelector('[data-ac-quantity-ink]');
      if (ink) {
        const syncInk = () => ink.toggleAttribute('data-ready', ink.complete && ink.naturalWidth > 0);
        ink.addEventListener('load', syncInk, { signal: abort.signal });
        ink.addEventListener('error', syncInk, { signal: abort.signal });
        syncInk();
      }
      const change = (delta = 0) => update(Number(input.value) + delta * Number(input.step || 1), input);
      input.addEventListener('change', () => change(), { signal: abort.signal });
      control.querySelector('[data-ac-quantity-minus]')?.addEventListener('click', () => change(-1), { signal: abort.signal });
      control.querySelector('[data-ac-quantity-plus]')?.addEventListener('click', () => change(1), { signal: abort.signal });
    }
    return () => abort.abort();
  };
  window.AcProductQuantity = { normalize, bind };
})();
